import { render, staticRenderFns } from "./UiInputWrapper.vue?vue&type=template&id=c25063b4&lang=pug&"
import script from "./UiInputWrapper.vue?vue&type=script&lang=js&"
export * from "./UiInputWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports